import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import DynamicTable from '@atlaskit/dynamic-table';
import { Text } from '@atlaskit/primitives';

const i18n = defineMessages({
	spacesTableHeader: {
		id: 'bulk-permissions.space.space-selection-table.header.non-final',
		defaultMessage: 'Spaces',
		description: 'message for when the space selection table is empty',
	},
	emptyMessage: {
		id: 'bulk-permissions.space.space-selection-table.empty-message.non-final',
		defaultMessage: 'No spaces added yet',
		description: 'message for when the space selection table is empty',
	},
});

const head = {
	cells: [
		{
			key: 'spaces',
			content: i18n.spacesTableHeader.defaultMessage,
			isSortable: true,
		},
	],
};

const rows = [];

export const SelectedSpacesTable = () => {
	const { formatMessage } = useIntl();
	return (
		<>
			<DynamicTable
				head={head}
				rows={rows}
				isFixedSize
				emptyView={<Text>{formatMessage(i18n.emptyMessage)}</Text>}
				defaultSortKey="number"
				defaultSortOrder="ASC"
				testId="space-selection-panel-table"
			/>
		</>
	);
};
